<template>
  <section>
    <div class="content">
      <div class="row mb-3">
        <div class="col-md-6">
          <Titulo
            title="Pagamento"
            description="Efetue o pagamento do espaço escolhido para locação."
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Carrinho :title="'Informações do Plano'" :list="lista" />
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <FormasPagamento
            :formasPagamento="formasPagamento"
            :validarAceite="false"
            :loading="loading"
            @method="efetuarpagamento"
          />
        </div>
      </div>
    </div>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          link="/produto/cdl-varejo-inteligente/termo"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Carrinho from "@/components/pagamento/Carrinho";
import FormasPagamento from "@/components/pagamento/MetodosPagamento";
export default {
  name: "VarejoInteligentePagamento",
  components: { Titulo, Botao, Carrinho, FormasPagamento },
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CDL Varejo Inteligente",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente",
        },
        {
          nome: "Pagamento",
          id: "pagamento",
          produto: "CDL Varejo Inteligente",
        },
      ],
      formasPagamento: {
        cartaocredito: true,
        boleto: {
          status: true,
          msg: "",
        },
        mensalidade: true,
      },
      loading: false,
      lista: [],
      eventoId: null,
    };
  },
  methods: {
    async efetuarpagamento(payload) {
      this.loading = true;
      if (payload.type === "Boleto") {
        this.$http
          .post(
            `/api/Agenda/RegistrarBoletoVarejoInteligente?eventoid=${this.eventoId}`
          )
          .then((response) => {
            if (response.data.sucesso) {
              sessionStorage.removeItem("reserva");
              this.$toast.open({
                message:
                  "Boleto gerado com sucesso! Redirecionando para o painel de reservas...",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "varejo",
                });
              }, 2000);
              window.open(response.data.urlBoleto);
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          });
      } else if (payload.type === "Cartao") {
        const dadosCartao = payload.payload.dataCard;
        this.$http
          .post("/api/Agenda/PagamentoCreditoVarejoInteligente", {
            nomeCartao: dadosCartao.nomeCartao,
            numeroCartao: dadosCartao.numeroCartao,
            dataExpiracaoCartao: dadosCartao.dataExpiracaoCartao,
            codigoValidacaoCartao: dadosCartao.codigoValidacaoCartao,
            eventoId: this.eventoId,
          })
          .then((response) => {
            if (response.data.sucesso) {
              sessionStorage.removeItem("reserva");
              this.$toast.open({
                message:
                  "Pagamento finalizado com sucesso! Redirecionando o painel de reservas...",
                type: "success",
              });
              this.loading = false;
              setTimeout(() => {
                this.$router.push({
                  name: "varejo",
                });
              }, 2000);
            } else {
              this.loading = false;
              this.$toast.open({
                message:
                  "Erro ao processar seu pagamento, verifique os dados do cartão e tente novamente.",
                type: "warning",
              });
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.message,
              type: "warning",
            });
          });
      } else if (payload.type === "Mensalidade") {
        this.$http
          .post(
            `/api/Agenda/PagamentoBoletoMensalVarejoInteligente?eventoid=${this.eventoId}`
          )
          .then((response) => {
            if (response.data.sucesso) {
              sessionStorage.removeItem("reserva");
              this.$toast.open({
                message:
                  "Valor registrado no boleto mensal! Redirecionando para o painel de reservas...",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "varejo",
                });
              }, 2000);
            }
          })
          .catch((error) => {
            if (error.statusCode === 401) {
              this.$router.push({ name: "login" });
            }
            this.loading = false;
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          });
      }
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);

    const session = JSON.parse(sessionStorage.getItem("reserva"));
    this.eventoId = session.reserva.simulado.eventoId;
    var desc = "";
    if (session.tipoReserva === "rooftop") {
      desc = session.reserva.simulado.espaco + " - " + "Entrada de 50%";
    } else {
      desc = session.reserva.simulado.espaco;
    }
    if (session.reserva.simulado) {
      this.lista = [
        {
          desc: desc,
          info:
            "Data " +
            session.agenda.dia.dia +
            " de " +
            session.agenda.dia.mes +
            " de " +
            session.agenda.dia.ano +
            " - " +
            session.agenda.horarios.horaInicio +
            " - " +
            session.agenda.horarios.horaFim,
          value: session.reserva.simulado.valor,
        },
      ];
    }

    if (this.$user.naoAssociado) {
      this.formasPagamento.mensalidade = false;
    }
  },
};
</script>
